import {
  MarketPlaceLandTabsType,
  MarketPlaceMainTabsType,
} from "../types/pages/MarketPlace";
import { IsBeta } from "../utils/Network";
import { Assets } from "./assets";

export const LAND_TABS: MarketPlaceLandTabsType[] = [
  {
    title: "Desert",
    imageSrc:
      "https://core.chainoflegends.com/Admin/files/Photos/Lands/1/land-desert.png",
    id: 1,
    className: "third-step",
  },
  {
    title: "Common",
    imageSrc:
      "https://core.chainoflegends.com/Admin/files/Photos/Lands/2/land-common.png",
    id: 2,
    className: "mrkt-stp2",
  },
  {
    title: "Uncommon",
    imageSrc:
      "https://core.chainoflegends.com/Admin/files/Photos/Lands/3/land-uncommon.png",
    id: 3,
  },
  {
    title: "Rare",
    imageSrc:
      "https://core.chainoflegends.com/Admin/files/Photos/Lands/4/land-rare.png",
    id: 4,
  },
  {
    title: "Legendary",
    imageSrc:
      "https://core.chainoflegends.com/Admin/files/Photos/Lands/5/land-legendary.png",
    id: 5,
  },
];

